<app-pagelayout>
  <div class="filter-page">
      <div *ngIf="isSaving" class="spinner-overlay">
        <sh-spinner></sh-spinner>
      </div>
    <div class="flex-row mb-perc-1">
        <sh-breadcrumbs>
          <sh-breadcrumb-item id="tt-home" label='Home' (keydown)="routeToHome()" (click)="routeToHome()"></sh-breadcrumb-item>
          <sh-breadcrumb-item label='Create new query'></sh-breadcrumb-item>
        </sh-breadcrumbs>
        <sh-tooltip delay target="tt-home" [label]="'filter-criteria.tooltip.home' | translate" placement="bottom" variation="short"></sh-tooltip>
      </div>
      
      <div class="card-style">
        <div class="head" slot="header">
      
          <div class="header-left">
            <sh-text size="header-1">
              {{ ('filter-criteria.query-expand-modal' | translate) + ((dataService.selectedQuery?.name) ? ' :' : '') }}
            </sh-text>
      
            <sh-text class="ml-10" size="header-1">
              {{ dataService.selectedQuery?.name }}
            </sh-text>
      
            <span id="tt-unsaved" class="ml-10" *ngIf="hasChanges() || (!dataService.selectedGUID && !isNewFilterSaved)">
              <sh-tag label="Unsaved" color="241, 158,130"></sh-tag>
            </span>
            <sh-tooltip *ngIf="hasChanges() || (!dataService.selectedGUID && !isNewFilterSaved)" delay target="tt-unsaved" [label]="'filter-criteria.tooltip.unsaved' | translate" placement="top" variation="short"></sh-tooltip>
          </div>
      
          <div class="header-actions">
            <sh-button size="auto" *ngIf="dataService.selectedGUID && updatedVersion && !isTemplateFilter()" color="tertiary"
              (click)="openVersionHistoryModal()" (keydown.enter)="openVersionHistoryModal()" [label]="'Version: ' + formatVersion(updatedVersion)">
            </sh-button>
      
            <sh-button id="tt-usetemplate" size="auto" color="tertiary" (click)="openTemplateModal()" (keydown.enter)="openTemplateModal()" label="Load Template/Query">
            </sh-button>
            <sh-tooltip delay target="tt-usetemplate" [label]="'filter-criteria.tooltip.useTemplate' | translate" placement="top" variation="long"></sh-tooltip>
          </div>
      
        </div>
      <div class="filter-body">
        <!-- LEFT: Manual Query Builder -->
        <div class="filter-left">
          <div class="or-logic-hint">
            <sh-icon icon="information" size="s"></sh-icon>
            <span>
              <strong>Tip: Comma-separated values in text fields (e.g. <em>A, B, C</em>) or multiple selections in dropdowns are treated as an <strong>OR</strong> condition  —  any matching value will be included in results.</strong>
            </span>
          </div>
          <!-- Scroll area with all groups -->
        <ng-template #reusableQueryTemplate let-isModal="isModal">
          <div class="condition-scroll-area" cdkDropListGroup 
               [style.max-height]="isModal ? 'calc(80vh - 250px)' : (filterCriteriaDataService.scrollAreaHeight + 'px')"
               [style.overflow-y]="'auto'">
            <div class="version-history-controls">
            </div>
            <app-filter-criteria-group 
              [isLoaded]="isFilterCriteriaLoaded"
              [isModal]="isModal" 
              (openSingleValueRequested)="openSingleValueModal($event)">
            </app-filter-criteria-group>
          </div>

          <div class="filter-footer-actions" *ngIf="isModal">
            <sh-button
              id="tt-addgroup-modal"
              color="secondary" size="m"
              label="{{ 'filter-criteria.add-group' |  translate }}"
              icon="plus-light"
              class="add-group-button"
              (click)="addNewGroup('OR')"
              icon-position="left"
              [disabled]="dataService.isRolloutUpdated">
            </sh-button>
            <sh-tooltip delay target="tt-addgroup-modal" [label]="'filter-criteria.tooltip.addGroup' | translate" placement="top" variation="long"></sh-tooltip>

            <sh-button
              id="tt-testrun-modal"
              class="footer-btn"
              color="secondary" size="m"
              label="Test Run"
              (click)="onRefreshSummary(); testRun()"
              (keydown.enter)="onRefreshSummary(); testRun()"
              [disabled]="isAnyConditionValueEmpty() || dataService.isRolloutUpdated"
              icon="workflow-open"
              icon-position="left">
            </sh-button>
            <sh-tooltip delay target="tt-testrun-modal" [label]="'filter-criteria.tooltip.testRun' | translate" placement="top" variation="long"></sh-tooltip>

            <sh-button
              *ngIf="!dataService.selectedGUID"
              id="tt-save-modal"
              class="footer-btn"
              label="Save"
              (click)="openSaveModel()"
              [disabled]="isAnyConditionValueEmpty()">
              >
            </sh-button>
            <sh-tooltip *ngIf="!dataService.selectedGUID" delay target="tt-save-modal" [label]="'filter-criteria.tooltip.save' | translate" placement="top" variation="long"></sh-tooltip>

            <sh-split-button id="tt-runandsave-modal" *ngIf="dataService.selectedGUID && !isTemplateFilter()" class="footer-btn" [label]="!isAnyConditionValueEmpty() ? 'Run and Save' : 'Save'" color="primary" size="auto"
              (click)="runPrimarySaveAction()" (keydown.enter)="runPrimarySaveAction()">
              <sh-menu-item *ngIf="!isAnyConditionValueEmpty()" label="Save" (click)="$event.stopPropagation(); onSave()" (keydown.enter)="$event.stopPropagation(); onSave()">
              </sh-menu-item>
              <sh-menu-item label="Save As" (click)="$event.stopPropagation(); isSaveAsModalVisible = true" (keydown.enter)="$event.stopPropagation(); isSaveAsModalVisible = true">
              </sh-menu-item>
            </sh-split-button>
            <sh-tooltip *ngIf="dataService.selectedGUID && !isTemplateFilter()" delay target="tt-runandsave-modal" [label]="'filter-criteria.tooltip.runAndSave' | translate" placement="top" variation="long"></sh-tooltip>

            <sh-split-button *ngIf="dataService.selectedGUID && isTemplateFilter()" class="footer-btn" label="Save" color="primary" size="auto"
              (click)="onRefreshSummary(); onRunAndSave()" (keydown.enter)="onRefreshSummary(); onRunAndSave()">
              <sh-menu-item label="Save As" (click)="$event.stopPropagation(); isSaveAsModalVisible = true">
              </sh-menu-item>
            </sh-split-button>

          <sh-split-button id="tt-clearall-modal" color="secondary" label="Clear All" (click)="clearAllFilters()" (keydown.enter)="clearAllFilters()">
            <sh-menu-item label="Clear only values" (click)="$event.stopPropagation(); clearOnlyValues()" (keydown.enter)="clearOnlyValues()">
            </sh-menu-item>
          </sh-split-button>

        <sh-tooltip delay target="tt-clearall-modal" [label]="'filter-criteria.tooltip.clear' | translate" placement="top" variation="long"></sh-tooltip>
            <sh-icon
              id="tt-expand-modal"
              style="cursor: pointer;"
              *ngIf="!expandManualQuery"
              [icon]="expandManualQuery ? 'exit-fullscreen' : 'fullscreen'" 
              (click)="openExpandModal()"></sh-icon>
            <sh-tooltip *ngIf="!expandManualQuery" delay target="tt-expand-modal" [label]="'filter-criteria.tooltip.expand' | translate" placement="top" variation="long"></sh-tooltip>

          </div>
          <sh-divider *ngIf="isModal"></sh-divider>
          <div *ngIf="isModal">
            <div class="summary-header">
                  <sh-icon id="tt-summary-modal" icon="sparkles" size="lg"></sh-icon>
                  <sh-tooltip delay target="tt-summary-modal" [label]="'filter-criteria.tooltip.summary' | translate" placement="top" variation="long"></sh-tooltip>
                  <sh-text size="subtitle"><strong><span id="tt-summarytext-modal">{{summaryTitle}}</span></strong></sh-text>
                  <sh-tooltip delay target="tt-summarytext-modal" [label]="'filter-criteria.tooltip.summary' | translate" placement="top" variation="long"></sh-tooltip>
                  <sh-icon icon="refresh" (click)="onRefreshSummary()" button [disabled]="dataService.isRolloutUpdated"></sh-icon>
            </div>
            <span *ngFor="let item of querySummary">
                <span style="margin-right: 8px;">{{ item.text }}</span>
            </span>
          </div>
        </ng-template>
        <div class="template-content-host">
          <ng-container *ngTemplateOutlet="reusableQueryTemplate; context: { isModal: false }"></ng-container>
        </div>

        <div class="filter-footer-actions page-footer-actions">
          <sh-button
            id="tt-addgroup-page"
            color="secondary" size="m"
            label="{{ 'filter-criteria.add-group' |  translate }}"
            icon="plus-light"
            class="add-group-button"
            (click)="addNewGroup('OR')"
            icon-position="left"
            [disabled]="dataService.isRolloutUpdated">
          </sh-button>
          <sh-tooltip delay target="tt-addgroup-page" [label]="'filter-criteria.tooltip.addGroup' | translate" placement="top" variation="long"></sh-tooltip>

          <sh-button
            id="tt-testrun-page"
            class="footer-btn"
            color="secondary" size="m"
            label="Test Run"
            (click)="onRefreshSummary(); testRun()"
            (keydown.enter)="onRefreshSummary(); testRun()"
            [disabled]="isAnyConditionValueEmpty() || dataService.isRolloutUpdated"
            icon="workflow-open"
            icon-position="left">
          </sh-button>
          <sh-tooltip delay target="tt-testrun-page" [label]="'filter-criteria.tooltip.testRun' | translate" placement="top" variation="long"></sh-tooltip>

          <sh-button
            *ngIf="!dataService.selectedGUID"
            id="tt-save-page"
            class="footer-btn"
            label="Save"
            (click)="openSaveModel()">
          </sh-button>
          <sh-tooltip *ngIf="!dataService.selectedGUID" delay target="tt-save-page" [label]="'filter-criteria.tooltip.save' | translate" placement="top" variation="long"></sh-tooltip>

          <sh-split-button id="tt-runandsave-page" *ngIf="dataService.selectedGUID && !isTemplateFilter() && !isFilterOwnedByOtherUser()" class="footer-btn" [label]="isAnyConditionValueEmpty() ? 'Save' : 'Run and Save'" color="primary" size="auto"
            (click)="runPrimarySaveAction()" (keydown.enter)="runPrimarySaveAction()">
            <sh-menu-item *ngIf="!isAnyConditionValueEmpty()" label="Save" (click)="$event.stopPropagation(); onSave()" (keydown.enter)="$event.stopPropagation(); onSave()" [disabled]="isAnyConditionValueEmpty()">
            </sh-menu-item>
            <sh-menu-item label="Save As" (click)="$event.stopPropagation(); isSaveAsModalVisible = true" (keydown.enter)="$event.stopPropagation(); isSaveAsModalVisible = true">
            </sh-menu-item>
          </sh-split-button>
          <sh-tooltip *ngIf="dataService.selectedGUID && !isTemplateFilter() && !isFilterOwnedByOtherUser()" delay target="tt-runandsave-page" [label]="'filter-criteria.tooltip.runAndSave' | translate" placement="top" variation="long"></sh-tooltip>

          <sh-split-button *ngIf="dataService.selectedGUID && isTemplateFilter() && !isFilterOwnedByOtherUser()" class="footer-btn" label="Save" color="primary" size="auto"
            (click)="onRefreshSummary(); onRunAndSave()" (keydown.enter)="onRefreshSummary(); onRunAndSave()">
            <sh-menu-item label="Save As" (click)="$event.stopPropagation(); isSaveAsModalVisible = true">
            </sh-menu-item>
          </sh-split-button>
          <sh-button
            *ngIf="dataService.selectedGUID && isFilterOwnedByOtherUser()"
            class="footer-btn"
            label="Save As"
            (click)="$event.stopPropagation(); isSaveAsModalVisible = true"
            [disabled]="isAnyConditionValueEmpty()">
          </sh-button>
           <sh-split-button id="tt-clear-page" color="secondary" label="Clear All" (click)="clearAllFilters()" (keydown.enter)="clearAllFilters()">
            <sh-menu-item label="Clear only values" (click)="$event.stopPropagation(); clearOnlyValues()" (keydown.enter)="clearOnlyValues()">
            </sh-menu-item>
          </sh-split-button>
          <sh-tooltip delay target="tt-clear-page" [label]="'filter-criteria.tooltip.clear' | translate" placement="top" variation="long"></sh-tooltip>
          <sh-icon
            id="tt-expand-page"
            style="cursor: pointer;"
            *ngIf="!expandManualQuery"
            [icon]="expandManualQuery ? 'exit-fullscreen' : 'fullscreen'"
            (click)="openExpandModal()" (keydown.enter)="openExpandModal()"></sh-icon>
          <sh-tooltip *ngIf="!expandManualQuery" delay target="tt-expand-page" [label]="'filter-criteria.tooltip.expand' | translate" placement="top" variation="long"></sh-tooltip>
        </div>

        <sh-divider></sh-divider>
        <div class="page-summary-section">
          <div class="summary-header">
            <sh-icon id="tt-summary-page" icon="sparkles" size="lg"></sh-icon>
            <sh-tooltip delay target="tt-summary-page" [label]="'filter-criteria.tooltip.summary' | translate" placement="top" variation="long"></sh-tooltip>
            <sh-text size="subtitle"><strong><span id="tt-summarytext-page">{{summaryTitle}}</span></strong></sh-text>
            <sh-tooltip delay target="tt-summarytext-page" [label]="'filter-criteria.tooltip.summary' | translate" placement="top" variation="long"></sh-tooltip>
            <sh-icon icon="refresh" (click)="onRefreshSummary()" (keydown.enter)="onRefreshSummary()" button [disabled]="dataService.isRolloutUpdated"></sh-icon>
          </div>
          <span *ngFor="let item of querySummary">
            <span style="margin-right: 8px;">{{ item.text }}</span>
          </span>
        </div>

      <sh-modal 
        [visible]="expandManualQuery" 
        class="manual-query-expand-modal" 
        [label]="'filter-criteria.query-expand-modal' | translate" 
        modal-height='fit-content' 
        modal-width='95vw' 
        style="z-index: 103;" 
        (modal-closed)="expandManualQuery = false">
        <ng-container *ngTemplateOutlet="reusableQueryTemplate; context: { isModal: true }"></ng-container>
      </sh-modal>
      </div>
        
        </div>
      </div>
  </div>

  <app-notification *ngIf="notification" [notification]="notification"></app-notification>

  <sh-modal sticky id='range-viewer-modal' [label]="getModalTitle()" modal-height='560px' modal-width='820px' 
            [visible]="showRangeDialog" (closed)="closeSingleValueModal()"style="z-index: 103;">
    
    <div class="range-viewer-content">
      <!-- Warning note for software version field -->
      <div *ngIf="currentRangeCondition?.field?.toLowerCase() === 'software version'" 
           class="software-version-warning" 
           style="margin-bottom: 15px; padding: 12px; background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px; border-left: 4px solid #ff9800;">
        <div style="display: flex; align-items: flex-start; gap: 8px;">
          <sh-icon icon="warning" style="color: #ff9800; margin-top: 2px;"></sh-icon>
          <div>
            <sh-text size="caption" style="font-weight: bold; color: #856404;">Note:</sh-text>
            <sh-text size="caption" style="color: #856404; display: block; margin-top: 4px;">
              Range functionality (e.g., VA10A-VA20A) is not supported for Software Version field. 
            </sh-text>
          </div>
        </div>
      </div>
      
      <div class="search-container">
        <sh-input-text 
          id="range-search" 
          label="Search Value(s)"
          placeholder="Type to search..."
          [(ngModel)]="rangeSearchText" 
          (ngModelChange)="onRangeSearchChange($event)"
          condensed>
        </sh-input-text>
        <sh-tooltip delay target="range-search" [label]="'filter-criteria.tooltip.searchValues' | translate" placement="bottom" variation="short"></sh-tooltip>
      </div>
      
      <div *ngIf="showDeleteMessage" class="delete-confirmation-message" 
           style="padding: 8px; background-color: #d4edda; border: 1px solid #c3e6cb; border-radius: 4px; color: #155724;">
        <sh-icon icon="check_circle" style="color: #28a745; margin-right: 8px;"></sh-icon>
        <span>{{ deleteConfirmationMessage }}</span>
      </div>
      
      <div *ngIf="rangeSearchText && filteredRanges.length > 0" class="search-results-with-delete" style="margin-top: 10px; max-height: 200px; overflow-y: auto; border: 1px solid #ccc; border-radius: 4px; padding: 8px;">
        <sh-text size="caption" style="margin-bottom: 8px; display: block;">
          <strong>Found {{ filteredRanges.length }} matches - Click delete icon to remove:</strong>
        </sh-text>
        
        <div class="search-result-item" *ngFor="let value of filteredRanges; let i = index" 
             style="display: flex; justify-content: space-between; align-items: center; padding: 4px 8px; margin: 2px 0; background-color: #f5f5f5; border-radius: 3px;">
          <div style="display: flex; align-items: center; gap: 8px; flex: 1;">
            <span class="search-result-text">{{ value }}</span>
            <span *ngIf="isValueInIncluded(value)" 
                  style="font-size: 10px; padding: 2px 6px; background-color: #4caf50; color: white; border-radius: 10px; font-weight: bold;">
              INCLUDED
            </span>
            <span *ngIf="isValueInExcluded(value)" 
                  style="font-size: 10px; padding: 2px 6px; background-color: #f44336; color: white; border-radius: 10px; font-weight: bold;">
              EXCLUDED
            </span>
          </div>
          <sh-icon icon="delete"
                   (click)="deleteValue(value)" 
                   title="Delete this value"
                   style="cursor: pointer;">
          </sh-icon>
        </div>
      </div>
      
      <div class="no-search-results" *ngIf="rangeSearchText && filteredRanges.length === 0" 
           style="margin-top: 10px; padding: 8px; background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px;">
        <sh-text size="caption">No values found matching "{{ rangeSearchText }}"</sh-text>
      </div>
      
      <div class="input-row" style="display: flex; align-items: flex-start; gap: 10px;">
        <div style="flex: 1;">
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px; margin-top: 10px">
            <span style="font-weight: 700; color: #4caf50;">Equal - (Included Values ({{ getIncludedValuesCount() }}))</span>
          </div>
          <sh-input-text 
            id="included-values-input" 
            [label]="currentRangeCondition?.field?.toLowerCase() === 'software version' 
                     ? 'Enter values (comma-separated, wildcards like %1.2%, *beta* - ranges not supported)' 
                     : 'Enter values (comma-separated, ranges like 123-456, wildcards like %value%)'"
            [(ngModel)]="includedValues"
            (ngModelChange)="onIncludedValuesChange($event)"
            textarea
            rows="4"
            class="main-input" condensed>
          </sh-input-text>
          <sh-tooltip delay target="included-values-input" [label]="'filter-criteria.tooltip.includedValues' | translate" placement="top" variation="long"></sh-tooltip>
        </div>
        
        <input type="file" accept=".xlsx" hidden #includedFileInput (change)="onIncludedFileUpload($event)" />
        <sh-icon id="tt-included-upload" icon="upload" button (click)="includedFileInput.click()" 
                 class="upload-icon" style="margin-top: 28px;"></sh-icon>
        <sh-tooltip delay target="tt-included-upload" [label]="'filter-criteria.tooltip.includedUpload' | translate" placement="top" variation="long"></sh-tooltip>
      </div>

      <div class="input-row" style="display: flex; align-items: flex-start; gap: 10px; margin-top: 20px;">
        <div style="flex: 1;">
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
            <span style="font-weight: 700; color: #f44336;">Not Equal - (Excluded Values ({{ getExcludedValuesCount() }}))</span>
          </div>
          <sh-input-text 
            id="excluded-values-input" 
            [label]="currentRangeCondition?.field?.toLowerCase() === 'software version' 
                     ? 'Enter values to exclude (comma-separated, wildcards like %1.2%, *beta* - ranges not supported)' 
                     : 'Enter values to exclude (comma-separated, ranges like 123-456, wildcards like %value%)'"
            [(ngModel)]="excludedValues"
            (ngModelChange)="onExcludedValuesChange($event)"
            textarea
            rows="4"
            class="main-input" condensed>
          </sh-input-text>
          <sh-tooltip delay target="excluded-values-input" [label]="'filter-criteria.tooltip.excludedValues' | translate" placement="top" variation="long"></sh-tooltip>
        </div>
        
        <input type="file" accept=".xlsx" hidden #excludedFileInput (change)="onExcludedFileUpload($event)" />
        <sh-icon id="tt-excluded-upload" icon="upload" button (click)="excludedFileInput.click()" 
                 class="upload-icon" style="margin-top: 28px;"></sh-icon>
        <sh-tooltip delay target="tt-excluded-upload" [label]="'filter-criteria.tooltip.excludedUpload' | translate" placement="top" variation="long"></sh-tooltip>
      </div>
      
    </div>
    <sh-button id="tt-cancel-range" slot='footer' color='secondary' label='Cancel' (click)="closeSingleValueModal()"></sh-button>
    <sh-tooltip delay target="tt-cancel-range" [label]="'filter-criteria.tooltip.cancelDialog' | translate" placement="top" variation="short"></sh-tooltip>
    <sh-button id="tt-add-range" [disabled]="getIncludedValuesCount() === 0 && getExcludedValuesCount() === 0" slot='footer' label='Add' (click)="addValuesToField()" (keydown)="addValuesToField()"></sh-button>
    <sh-tooltip delay target="tt-add-range" [label]="'filter-criteria.tooltip.addValues' | translate" placement="top" variation="long"></sh-tooltip>
  </sh-modal>

</app-pagelayout>

<sh-modal sticky [visible]="isModalVisible" label='Save As'
  modal-height="fit-content"
  modal-width="600px"
  class="saveas-modal"
  style="z-index: 103;"
  (modal-closed)="isModalVisible = false">

  <div class="save-query-body">

    <sh-radio-group horizontal [disabled]="isSaving" class="save-as-radio-group">
        <sh-radio-button
          id="tt-sa1-radio-query"
          label="Query"
          [active]="savedFilterType === 'Standard'"
          (active-changed)="savedFilterType = 'Standard';isDefaultQuery = false"
          [disabled]="isSaving">
        </sh-radio-button>
        <sh-radio-button
          id="tt-sa1-radio-personal"
          label="Personal Template"
          [active]="savedFilterType === 'Template'"
          (active-changed)="savedFilterType = 'Template'"
          [disabled]="isSaving">
        </sh-radio-button>
        <sh-radio-button
          id="tt-sa1-radio-public"
          *ngIf="checkAccessRole(supportUserRole)"
          label="Public Template"
          [active]="savedFilterType === 'Public_Template'"
          (active-changed)="savedFilterType = 'Public_Template'"
          [disabled]="isSaving">
        </sh-radio-button>
    </sh-radio-group>
    <sh-tooltip delay target="tt-sa1-radio-query" [label]="'filter-criteria.tooltip.saveRadioQuery' | translate" placement="bottom" variation="short"></sh-tooltip>
    <sh-tooltip delay target="tt-sa1-radio-personal" [label]="'filter-criteria.tooltip.saveRadioPersonal' | translate" placement="bottom" variation="short"></sh-tooltip>
    <sh-tooltip *ngIf="checkAccessRole(supportUserRole)" delay target="tt-sa1-radio-public" [label]="'filter-criteria.tooltip.saveRadioPublic' | translate" placement="bottom" variation="short"></sh-tooltip>

    <div class="save-query-row save-query-row--two-col" style="margin-bottom: 12px;">
      <div class="save-query-field">
        <sh-input-text
          id="tt-sa1-name"
          condensed
          mandatory
          label="Name"
          [(ngModel)]="filterName"
          (input)="onSaveRestriction($event)"
          maxlength="50"
          [disabled]="isSaving">
        </sh-input-text>
        <sh-tooltip delay target="tt-sa1-name" [label]="(savedFilterType === 'Standard' ? 'filter-criteria.tooltip.saveNameQuery' : 'filter-criteria.tooltip.saveNameTemplate') | translate" placement="top" variation="short"></sh-tooltip>
      </div>
      <div class="save-query-field">
        <sh-input-text id="tt-sa1-projectid" *ngIf="savedFilterType === 'Standard'" condensed style="margin-top: 1%" label="{{ 'basic-info.label.projectId' | translate }}" [(ngModel)]="inputProjectId" (input)="onSaveRestrictionForProjectId($event)" maxlength="25" [disabled]="isSaving"></sh-input-text>
        <sh-tooltip *ngIf="savedFilterType === 'Standard'" delay target="tt-sa1-projectid" [label]="'filter-criteria.tooltip.saveProjectId' | translate" placement="top" variation="short"></sh-tooltip>
      </div>
    </div>

    <div class="save-query-row" style="margin-bottom: 12px;">
      <sh-input-text
        id="tt-sa1-desc"
        ngDefaultControl
        condensed
        textarea
        rows="3"
        label="Description (Optional)"
        [(ngModel)]="comments"
        (input)="onDescriptionInput()"
        [disabled]="isSaving">
      </sh-input-text>
      <div *ngIf="descriptionError" class="save-description-error">
        {{ descriptionError }}
      </div>
      <sh-tooltip delay target="tt-sa1-desc" [label]="(savedFilterType === 'Standard' ? 'filter-criteria.tooltip.saveDescQuery' : 'filter-criteria.tooltip.saveDescTemplate') | translate" placement="top" variation="long"></sh-tooltip>
    </div>

    <div class="save-query-section">
      <!-- Use savedFilterType (not whichFilterType) for isModalVisible modal -->
      <ng-container>

        <sh-checkbox
          id="qq-sa1-favorite"
          label="Save as Favorite"
          [active]="setAsFavoriteFilter"
          (checked)="setAsFavoriteFilter = !setAsFavoriteFilter"
          [disabled]="isSaving">
        </sh-checkbox>
        <div *ngIf="savedFilterType !== 'Standard'" class="save-default-option">
          <sh-checkbox
            id="tt-sa1-default"
            label="Save as Default"
            [active]="isDefaultQuery"
            (checked)="isDefaultQuery = !isDefaultQuery"
            [disabled]="isSaving">
          </sh-checkbox>
          <sh-tooltip delay target="tt-sa1-default" [label]="'filter-criteria.tooltip.saveDefault' | translate" placement="top" variation="long"></sh-tooltip>
                    <sh-checkbox
            id="tt-sa1-withvalues"
            label="Save with values"
            [active]="isSaveWithValues"
            (checked)="isSaveWithValues = !isSaveWithValues"
            [disabled]="isSaving">
          </sh-checkbox>
          <sh-icon
            [id]="isSaveWithValues ? 'tt-sa1-withvalues-info' : 'tt-sa1-withvalues-warning'"
            [icon]="isSaveWithValues ? 'information' : 'warning'"
            size="s"
            class="save-values-state-icon">
          </sh-icon>
          <sh-tooltip delay target="tt-sa1-withvalues" [label]="'filter-criteria.tooltip.saveWithValues' | translate" placement="top" variation="long"></sh-tooltip>
          <sh-tooltip
            *ngIf="isSaveWithValues"
            delay
            target="tt-sa1-withvalues-info"
            [label]="'filter-criteria.tooltip.saveWithValuesSelected' | translate"
            placement="top"
            variation="long">
          </sh-tooltip>
          <sh-tooltip
            *ngIf="!isSaveWithValues"
            delay
            target="tt-sa1-withvalues-warning"
            [label]="'filter-criteria.tooltip.saveWithValuesDefault' | translate"
            placement="top"
            variation="long">
          </sh-tooltip>
        </div>
      </ng-container>
    </div>

  </div>

  <sh-button id="tt-sa1-cancel" slot="footer" color="secondary" label="Cancel" (click)="isModalVisible = false" [disabled]="isSaving"></sh-button>
  <sh-tooltip delay target="tt-sa1-cancel" [label]="'filter-criteria.tooltip.saveCancel' | translate" placement="top" variation="short"></sh-tooltip>
  <sh-button id="tt-sa1-save" slot="footer" size="auto" label="Save" (click)="onSaveQueryFilter()"
    [disabled]="isSaving || !savedFilterType || !filterName || !filterName.trim() || !!descriptionError">
  </sh-button>
  <sh-tooltip delay target="tt-sa1-save" [label]="'filter-criteria.tooltip.saveSubmit' | translate" placement="top" variation="short"></sh-tooltip>

</sh-modal>

<sh-modal [visible]="isSaveAsModalVisible" label='Save Query'
  modal-height="fit-content"
  modal-width="600px"
  class="saveas-modal"
  style="z-index: 103;"
  (modal-closed)="isSaveAsModalVisible = false">

  <div class="save-query-body">

    <sh-radio-group horizontal [disabled]="isSaving" class="save-as-radio-group">
        <sh-radio-button
          id="tt-sa2-radio-query"
          label="Query"
          [active]="whichFilterType === 'Standard'"
          (active-changed)="whichFilterType = 'Standard';isDefaultQuery = false"
          [disabled]="isSaving">
        </sh-radio-button>
        <sh-radio-button
          id="tt-sa2-radio-personal"
          label="Personal Template"
          [active]="whichFilterType === 'Template'"
          (active-changed)="whichFilterType = 'Template'; isSaveWithValues = false"
          [disabled]="isSaving">
        </sh-radio-button>
        <sh-radio-button
          id="tt-sa2-radio-public"
          *ngIf="checkAccessRole(supportUserRole)"
          label="Public Template"
          [active]="whichFilterType === 'Public_Template'"
          (active-changed)="whichFilterType = 'Public_Template'"
          [disabled]="isSaving">
        </sh-radio-button>
    </sh-radio-group>
    <sh-tooltip delay target="tt-sa2-radio-query" [label]="'filter-criteria.tooltip.saveRadioQuery' | translate" placement="bottom" variation="short"></sh-tooltip>
    <sh-tooltip delay target="tt-sa2-radio-personal" [label]="'filter-criteria.tooltip.saveRadioPersonal' | translate" placement="bottom" variation="short"></sh-tooltip>
    <sh-tooltip *ngIf="checkAccessRole(supportUserRole)" delay target="tt-sa2-radio-public" [label]="'filter-criteria.tooltip.saveRadioPublic' | translate" placement="bottom" variation="short"></sh-tooltip>

    <!-- Row 1: Name + Project ID -->
    <div class="save-query-row save-query-row--two-col" style="margin-bottom: 12px;">
      <div class="save-query-field">
        <sh-input-text
          id="tt-sa2-name"
          condensed
          mandatory
          label="Name"
          [(ngModel)]="filterName"
          (input)="onSaveRestriction($event)"
          maxlength="50"
          [disabled]="isSaving">
        </sh-input-text>
        <sh-tooltip delay target="tt-sa2-name" [label]="(whichFilterType === 'Standard' ? 'filter-criteria.tooltip.saveNameQuery' : 'filter-criteria.tooltip.saveNameTemplate') | translate" placement="top" variation="short"></sh-tooltip>
      </div>
      <div class="save-query-field">
        <sh-input-text id="tt-sa2-projectid" *ngIf="whichFilterType != 'Template' && whichFilterType != 'Public_Template'" condensed style="margin-top: 1%" label="{{ 'basic-info.label.projectId' | translate }}" [(ngModel)]="inputProjectId" (input)="onSaveRestrictionForProjectId($event)" maxlength="25" [disabled]="isSaving"></sh-input-text>
        <sh-tooltip *ngIf="whichFilterType != 'Template' && whichFilterType != 'Public_Template'" delay target="tt-sa2-projectid" [label]="'filter-criteria.tooltip.saveProjectId' | translate" placement="top" variation="short"></sh-tooltip>
      </div>
    </div>

    <!-- Row 2: Description -->
    <div class="save-query-row" style="margin-bottom: 12px;">
      <sh-input-text
        id="tt-sa2-desc"
        ngDefaultControl
        condensed
        textarea
        rows="3"
        label="Description (Optional)"
        [(ngModel)]="comments"
        (input)="onDescriptionInput()"
        [disabled]="isSaving">
      </sh-input-text>
      <div *ngIf="descriptionError" class="save-description-error">
        {{ descriptionError }}
      </div>
      <sh-tooltip delay target="tt-sa2-desc" [label]="(whichFilterType === 'Standard' ? 'filter-criteria.tooltip.saveDescQuery' : 'filter-criteria.tooltip.saveDescTemplate') | translate" placement="top" variation="long"></sh-tooltip>
    </div>

    <!-- Save As Section -->
    <div class="save-query-section">
      <!-- Use whichFilterType for isSaveAsModalVisible modal -->
      <ng-container>

        <sh-checkbox
          id="tt-save-favorite"
          label="Save as Favorite"
          [active]="setAsFavoriteFilter"
          (checked)="setAsFavoriteFilter = !setAsFavoriteFilter"
          [disabled]="isSaving">
        </sh-checkbox>
        <div *ngIf="whichFilterType !== 'Standard'" class="save-default-option">
          <sh-checkbox
            id="tt-sa2-default"
            label="Save as Default"
            [active]="isDefaultQuery"
            (checked)="isDefaultQuery = !isDefaultQuery"
            [disabled]="isSaving">
          </sh-checkbox>
          <sh-tooltip delay target="tt-sa2-default" [label]="'filter-criteria.tooltip.saveDefault' | translate" placement="top" variation="long"></sh-tooltip>
          <sh-checkbox
            id="tt-sa2-withvalues"
            label="Save with values"
            [active]="isSaveWithValues"
            (checked)="isSaveWithValues = !isSaveWithValues"
            [disabled]="isSaving">
          </sh-checkbox>
          <sh-icon
            [id]="isSaveWithValues ? 'tt-sa2-withvalues-info' : 'tt-sa2-withvalues-warning'"
            [icon]="isSaveWithValues ? 'information' : 'warning'"
            size="s"
            class="save-values-state-icon">
          </sh-icon>
          <sh-tooltip delay target="tt-sa2-withvalues" [label]="'filter-criteria.tooltip.saveWithValues' | translate" placement="top" variation="long"></sh-tooltip>
          <sh-tooltip
            *ngIf="isSaveWithValues"
            delay
            target="tt-sa2-withvalues-info"
            [label]="'filter-criteria.tooltip.saveWithValuesSelected' | translate"
            placement="top"
            variation="long">
          </sh-tooltip>
          <sh-tooltip
            *ngIf="!isSaveWithValues"
            delay
            target="tt-sa2-withvalues-warning"
            [label]="'filter-criteria.tooltip.saveWithValuesDefault' | translate"
            placement="top"
            variation="long">
          </sh-tooltip>
        </div>
      </ng-container>
    </div>

  </div>

  <sh-button id="tt-sa2-cancel" slot="footer" color="secondary" label="Cancel" (click)="isSaveAsModalVisible = false" [disabled]="isSaving"></sh-button>
  <sh-tooltip delay target="tt-sa2-cancel" [label]="'filter-criteria.tooltip.saveCancel' | translate" placement="top" variation="short"></sh-tooltip>
  <sh-button id="tt-sa2-save" slot="footer" size="auto" label="Save" (click)="onSaveAs()"
    [disabled]="isSaving || !whichFilterType || !filterName || !filterName.trim() || !!descriptionError">
  </sh-button>
  <sh-tooltip delay target="tt-sa2-save" [label]="'filter-criteria.tooltip.saveSubmit' | translate" placement="top" variation="short"></sh-tooltip>

</sh-modal>

<sh-modal sticky [visible]="openClearConfirmModal" label="Unsaved Filter Detected" modal-height='200px' modal-width='450px'>
  <sh-text>{{ 'filter-criteria.discard-changes' | translate }}</sh-text>
  <div class="modal-footer-buttons" slot="footer">
    <sh-button  color="secondary" size="auto" label='Cancel' (click)="openClearConfirmModal = false" (keydown.enter)="openClearConfirmModal = false"></sh-button>
    <sh-button size="auto" label='Discard & Clear' (click)="onDiscardClear()" (keydown.enter)="onDiscardClear()"></sh-button>
    </div>
</sh-modal>

<sh-modal 
  [visible]="showVersionHistoryModal" 
  label="Version History" 
  modal-height='80vh' 
  modal-width='90vw' 
  style="z-index: 105;" 
  (modal-closed)="closeVersionHistoryModal()">
  
  <div class="version-history-content">
    <p-table class="version-history-table" [value]="filteredVersionHistory"
      styleClass="filter-criteria-modal-table"
      [reorderableColumns]="true" (onColReorder)="onVersionColumnReorder($event)"
      [scrollable]="true" scrollHeight="flex" [tableStyle]="{'min-width': '50rem'}">

      <!-- Header Row -->
      <ng-template pTemplate="header">
        <tr>
          <th class="select-col"></th>
          <th *ngFor="let col of versionColumns" class="vh-col" [ngClass]="'vh-col-' + col.field" pReorderableColumn [pSortableColumn]="col.field">
            <div class="column-title-sort" [id]="'tt-vh-head-' + col.field">
              <span>{{ col.header }}</span>
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </div>
            <sh-tooltip delay [target]="'tt-vh-head-' + col.field" [label]="col.headerTooltip | translate" placement="top" variation="long"></sh-tooltip>
          </th>
          <th class="actions-col">
            <span id="tt-vh-actions">Actions</span>
            <sh-tooltip delay target="tt-vh-actions" [label]="'filter-criteria.tooltip.vhActions' | translate" placement="top" variation="short"></sh-tooltip>
          </th>
        </tr>

        <!-- Filter Input Row -->
        <tr class="filter-inputs-row">
          <th class="select-col"></th>
          <th *ngFor="let col of versionColumns" class="vh-col" [ngClass]="'vh-col-' + col.field">
            <sh-input-text *ngIf="col.field === 'versionNo'" id="tt-vh-search-version" condensed label="Search..."
              [(ngModel)]="versionSearchText" (ngModelChange)="onVersionSearch()"></sh-input-text>
            <sh-input-text *ngIf="col.field === 'description'" id="tt-vh-search-description" condensed label="Search..."
              [(ngModel)]="descriptionSearchText" (ngModelChange)="onVersionSearch()"></sh-input-text>
            <sh-input-text *ngIf="col.field === 'filterCriteria'" id="tt-vh-search-criteria" condensed label="Search..."
              [(ngModel)]="filterCriteriaSearchText" (ngModelChange)="onVersionSearch()"></sh-input-text>
            <sh-tooltip *ngIf="col.searchTooltip" delay [target]="'tt-vh-search-' + col.field" [label]="col.searchTooltip | translate" placement="bottom" variation="short"></sh-tooltip>
          </th>
          <th class="actions-col"></th>
        </tr>
      </ng-template>

      <!-- Data Rows -->
      <ng-template pTemplate="body" let-version let-i="rowIndex">
        <tr [class.selected-row]="isVersionSelected(version)" (click)="onVersionRowClick(version)">
          <td class="select-col">
            <span [id]="'tt-vh-radio-' + i">
              <sh-radio-button label="" [active]="isVersionSelected(version)"
                (active-changed)="onVersionRadioChange(version)"
                (click)="$event.stopPropagation()">
              </sh-radio-button>
            </span>
            <sh-tooltip delay [target]="'tt-vh-radio-' + i" [label]="'filter-criteria.tooltip.vhRadio' | translate" placement="right" variation="long"></sh-tooltip>
          </td>
          <ng-container *ngFor="let col of versionColumns">
            <td *ngIf="col.field === 'versionNo'">{{ formatVersion(version.versionNo) }}</td>
            <td *ngIf="col.field === 'description'" class="vh-col vh-col-description description-cell">
              <div class="description-content">
                <span class="description-text" [title]="version.description || ''">{{ version.description || '—' }}</span>
                <sh-icon icon="edit" size="m" class="edit-comment-icon" [id]="'tt-vh-edit-' + i" button
                  (click)="onEditVersionComment(version, $event)"
                  (keydown)="onEditVersionComment(version, $event)"></sh-icon>
                <sh-tooltip delay [target]="'tt-vh-edit-' + i" [label]="'filter-criteria.tooltip.vhEdit' | translate" placement="top" variation="short"></sh-tooltip>
              </div>
            </td>
            <td *ngIf="col.field === 'filterCriteria'" [title]="version.filterCriteria">
              <span class="filter-criteria-text">{{ version.filterCriteria || '' }}</span>
            </td>
          </ng-container>
          <td class="actions-cell">
            <sh-icon icon="delete" size="m" class="delete-version-icon" [id]="'tt-vh-delete-' + i" button
              [disabled]="version.versionNo === updatedVersion"
              (click)="$event.stopPropagation(); version.versionNo !== updatedVersion && onDeleteVersionClick(version, $event)"></sh-icon>
            <sh-tooltip delay [target]="'tt-vh-delete-' + i" [label]="(version.versionNo === updatedVersion ? 'filter-criteria.tooltip.vhDeleteDisabled' : 'filter-criteria.tooltip.vhDelete') | translate" placement="top" variation="short"></sh-tooltip>
          </td>
        </tr>
      </ng-template>

      <!-- Empty State Row -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="versionColumns.length + 2" class="no-data-cell">
            No version history found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div slot="footer" class="modal-footer-buttons">
    <sh-button 
      id="tt-vh-cancel"
      color="secondary" 
      label="Cancel" 
      (click)="closeVersionHistoryModal()">
    </sh-button>
    <sh-tooltip delay target="tt-vh-cancel" [label]="'filter-criteria.tooltip.vhCancel' | translate" placement="top" variation="short"></sh-tooltip>
    <sh-button 
      id="tt-vh-load"
      label="Load" 
      (click)="loadSelectedVersion()"
      [disabled]="selectedVersions.length === 0">
    </sh-button>
    <sh-tooltip delay target="tt-vh-load" [label]="'filter-criteria.tooltip.vhLoad' | translate" placement="top" variation="long"></sh-tooltip>
  </div>
</sh-modal>

<sh-modal
  [visible]="editingVersionComment !== null"
  label="Edit Comment"
  modal-height='fit-content'
  modal-width='450px'
  style="z-index: 106;"
  (modal-closed)="onCancelEditVersionComment()">
  <sh-text size="body" *ngIf="editingVersionComment" style="margin-bottom: 8px;">
    Version: <span id="tt-evc-version">{{ formatVersion(editingVersionComment.versionNo) }}</span>
  </sh-text>
  <sh-tooltip *ngIf="editingVersionComment" delay target="tt-evc-version" [label]="'filter-criteria.tooltip.evcVersion' | translate" placement="right" variation="short"></sh-tooltip>
   <sh-input-text
    id="tt-evc-comment"
    ngDefaultControl
    condensed
    style="margin-top: 2%"
    textarea
    rows="13"
    label="Comment (max 600 characters)"
    [(ngModel)]="versionCommentText"
    (ngModelChange)="onVersionCommentChange($event)">
  </sh-input-text>
  <sh-tooltip delay target="tt-evc-comment" [label]="'filter-criteria.tooltip.evcComment' | translate" placement="top" variation="long"></sh-tooltip>
  <div *ngIf="versionCommentError" style="color: red; font-size: 12px; margin-top: 4px;">
    {{ versionCommentError }}
  </div>
  <sh-button
    id="tt-evc-cancel"
    color="secondary"
    slot="footer"
    label="Cancel"
    (click)="onCancelEditVersionComment()">
  </sh-button>
  <sh-tooltip delay target="tt-evc-cancel" [label]="'filter-criteria.tooltip.evcCancel' | translate" placement="top" variation="short"></sh-tooltip>
  <sh-button
    id="tt-evc-save"
    slot="footer"
    [label]="isSavingVersionComment ? 'Saving...' : 'Save'"
    (click)="onSaveVersionComment()"
    [disabled]="isSavingVersionComment || !!versionCommentError">
  </sh-button>
  <sh-tooltip delay target="tt-evc-save" [label]="'filter-criteria.tooltip.evcSave' | translate" placement="top" variation="short"></sh-tooltip>
</sh-modal>


<sh-modal 
  [visible]="showUnsavedChangesModal" 
  label="Save Changes" 
  modal-height="fit-content"
  modal-width='380px' 
  style="z-index: 106;" 
  (modal-closed)="closeUnsavedChangesModal()">
  
    <sh-text size="body">
    {{ pendingNavigation 
      ? ('filter-criteria.unsaved-changes-navigation' | translate)
      : pendingVersionToLoad
        ? ('filter-criteria.unsaved-changes-new-version' | translate)
        : ('filter-criteria.unsaved-changes-version' | translate) }}
  </sh-text>
  <div slot="footer" class="modal-footer-buttons">
    <sh-button 
      color="secondary" 
      label="Cancel" 
      size="auto"
      (click)="closeUnsavedChangesModal()">
    </sh-button>
    <sh-button 
      color="secondary" 
      label="Don't Save" 
      size="auto"
      (click)="onDontSaveAndLoad()">
    </sh-button>
    <sh-button 
      label="Save Changes" 
      size="auto"
      (click)="onSaveChangesAndLoad()">
    </sh-button>
  </div>
</sh-modal>


<!-- Delete Version Confirmation Modal -->
<sh-modal
  [visible]="showDeleteVersionModal"
  label="Delete Version"
  modal-height='200px'
  modal-width='400px'
  style="z-index: 107;"
  (modal-closed)="cancelDeleteVersion()">

  <sh-text size="body">
    Are you sure you want to delete version {{ versionToDelete ? formatVersion(versionToDelete.versionNo) : '' }}? This action cannot be undone.
  </sh-text>

  <div slot="footer" class="modal-footer-buttons">
    <sh-button
      color="secondary"
      label="Cancel"
      (click)="cancelDeleteVersion()">
    </sh-button>
    <sh-button
      color="primary"
      [label]="isDeletingVersion ? 'Deleting...' : 'Delete'"
      (click)="confirmDeleteVersion()"
      [disabled]="isDeletingVersion">
    </sh-button>
  </div>
</sh-modal>

<!-- Use Template Modal -->
<sh-modal
  [visible]="showTemplateModal"
  label=""
  modal-height='80vh'
  modal-width='90vw'
  style="z-index: 105;"
  (modal-closed)="closeTemplateModal()">

  <sh-tabs slot="header">
    <!-- active tab-items have the 'active' property, this property is transferred to clicked tabs -->
    <sh-tab-item label='Template List' [active]="activeTab === 'template'"
        (click)="setActiveTab('template')"></sh-tab-item>
    <sh-tab-item label='Query List'  [active]="activeTab === 'query'"
        (click)="setActiveTab('query')"></sh-tab-item>
  </sh-tabs>
  <div class="template-modal-content" *ngIf="activeTab === 'template'">
    <div class="search-row">
      <sh-search
        id="tt-tmpl-global-search"
        class="template-global-search"
        no-border
        [label]="'allQueryTable.searchByNameTemplateId' | translate"
        (input)="onTemplateGlobalSearchInput($event)"
        (clearsearch)="onTemplateGlobalSearchClear()">
      </sh-search>

      <sh-tooltip delay target="tt-tmpl-global-search" [label]="'allQueryTable.tooltip.searchTemplate' | translate" placement="bottom" variation="long"></sh-tooltip>

      <sh-button
        id="tt-tmpl-search-all"
        size="auto"
        label="Search All"
        [disabled]="isTemplateOthersSearchLoading || !(templateGlobalSearchText || '').trim() || isShowingTemplateOthersResults"
        (click)="onTemplateSearchOthers()"
        (keydown)="onTemplateSearchOthers()">
      </sh-button>
      <sh-tooltip delay target="tt-tmpl-search-all" [label]="'allQueryTable.tooltip.searchAll' | translate" placement="bottom" variation="long"></sh-tooltip>
    </div>

    <div class="summary-row">
      <sh-text size="body-2" class="total-count">
        <strong>Showing</strong> Templates:
        <strong>({{ filteredTemplateList.length }})</strong>
      </sh-text>

      <div class="header-icons">
        <sh-icon icon="layout-3x1" button color="black" size="m" id="tt-tmpl-cols-icon" (click)="toggleTemplateColumnVisibilityPopup()" (keydown)="toggleTemplateColumnVisibilityPopup()"></sh-icon>
        <sh-popover
          class="template-columns-popover"
          sticky
          [visible]="showTemplateColumnVisibilityPopup"
          target="tt-tmpl-cols-icon"
          label="Choose Columns"
          modal-height='20vh'
          modal-width='20vw'
          style="z-index: 106;">
          <ul class="template-columns-list">
            <li class="template-columns-item" *ngFor="let column of templateTableColumns">
              <div class="template-columns-label">
                <sh-checkbox
                  [(ngModel)]="column.visible"
                  (checked)="onTemplateColumnVisibilityChange(column, $event)">
                </sh-checkbox>
                <span>{{ column.label }}</span>
              </div>
            </li>
          </ul>
          <sh-button
            id="tt-tmpl-cols-close"
            class="template-columns-close"
            label="Close"
            slot='footer'
            color="Tertiary"
            size="auto"
            (click)="toggleTemplateColumnVisibilityPopup()">
          </sh-button>
        </sh-popover>
        <sh-tooltip delay target="tt-tmpl-cols-icon" [label]="'allQueryTable.tooltip.chooseColumns' | translate" placement="top" variation="long"></sh-tooltip>
        <sh-tooltip delay target="tt-tmpl-cols-close" [label]="'allQueryTable.tooltip.closeColumns' | translate" placement="top" variation="short"></sh-tooltip>
      </div>
    </div>

    <div
      *ngIf="isShowingTemplateOthersResults"
      style="display: flex; align-items: center; gap: 8px; padding: 6px 12px; background-color: #e8f4fd; border-left: 3px solid #006ADD; margin-bottom: 4px; margin-top: 2px;">
      <sh-icon icon="information" size="s" color="primary"></sh-icon>
      <sh-text size="body-2" style="align-content: center; margin-left: 5px">
        Showing template results from other users for "<strong>{{ templateGlobalSearchText }}</strong>"
      </sh-text>
    </div>

    <p-table class="template-table" [value]="filteredTemplateList"
      styleClass="filter-criteria-modal-table"
      [reorderableColumns]="true" (onColReorder)="onTemplateColumnReorder($event)"
      [scrollable]="true" scrollHeight="flex" [tableStyle]="{'min-width': '50rem'}">

      <ng-template pTemplate="header">
        <tr>
          <th class="select-col"></th>
          <th scope="col" *ngFor="let col of templateColumns" [ngClass]="'col-' + col.field" pReorderableColumn [pSortableColumn]="col.isSortable != false ? col.field : undefined" [hidden]="!isTemplateColumnVisible(col.field)">
            <div class="column-title-sort" [id]="'tt-tmpl-head-' + col.field">
              <span>{{ col.header }}</span>
              <p-sortIcon *ngIf="col.isSortable != false" [field]="col.field"></p-sortIcon>
            </div>
            <sh-tooltip delay [target]="'tt-tmpl-head-' + col.field" [label]="col.headerTooltip | translate" placement="top" variation="long"></sh-tooltip>
          </th>
        </tr>

        <tr class="filter-inputs-row">
          <th class="select-col"></th>
          <th scope="col" *ngFor="let col of templateColumns" [ngClass]="'col-' + col.field" [hidden]="!isTemplateColumnVisible(col.field)">
            <sh-input-text *ngIf="col.field === 'id'" id="tt-tmpl-search-id" condensed label="Search..."
              [(ngModel)]="templateIdSearchText" (ngModelChange)="onTemplateSearch()"></sh-input-text>
            <sh-input-text *ngIf="col.field === 'name'" id="tt-tmpl-search-name" condensed label="Search..."
              [(ngModel)]="templateNameSearchText" (ngModelChange)="onTemplateSearch()"></sh-input-text>
            <sh-dropdown *ngIf="col.field === 'type'" id="tt-tmpl-search-type" condensed label="Search..." multi-select
              [(ngModel)]="templateTypeSearchText" (value-changed)="onTemplateTypeFilter($event)">
              <sh-menu-item *ngFor="let type of ['Public', 'Personal']" [label]="type"></sh-menu-item>
            </sh-dropdown>
            <sh-input-text *ngIf="col.field === 'comments'" id="tt-tmpl-search-comments" condensed label="Search..."
              [(ngModel)]="templateCommentsSearchText" (ngModelChange)="onTemplateSearch()"></sh-input-text>
            <sh-tooltip delay [target]="'tt-tmpl-search-' + col.field" [label]="col.searchTooltip | translate" placement="bottom" variation="short"></sh-tooltip>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-template let-i="rowIndex">
        <tr [class.selected-row]="selectedTemplateItem?._uid === template._uid" (click)="onTemplateRadioChange(template)">
          <td class="select-col">
            <span [id]="'tt-tmpl-radio-' + i">
              <sh-radio-button label="" [active]="selectedTemplateItem?._uid === template._uid"
                (click)="$event.stopPropagation(); onTemplateRadioChange(template)"
                (keydown)="$event.stopPropagation(); onTemplateRadioChange(template)">
              </sh-radio-button>
            </span>
            <sh-tooltip delay [target]="'tt-tmpl-radio-' + i" [label]="'filter-criteria.tooltip.tmplRadio' | translate" placement="top" variation="short"></sh-tooltip>
          </td>
          <ng-container *ngFor="let col of templateColumns">
            <td *ngIf="col.field === 'favourite' && isTemplateColumnVisible(col.field)">
              <ng-container *ngIf="template.isFavourite; else nonFavoriteIcon">
                <div class="favorite-icon-wrapper">
                  <sh-icon class="favorite-icon-default" icon="favorite" size="s" color="primary" (click)="onToggleFavorite(false, template)"></sh-icon>
                </div>
              </ng-container>
              <ng-template #nonFavoriteIcon>
                <div class="favorite-icon-wrapper">
                  <sh-icon class="favorite-icon-hover" icon="favorite-off" size="s" color="primary" (click)="onToggleFavorite(true, template)"></sh-icon>
                </div>
              </ng-template>
            </td>
            <td *ngIf="col.field === 'id' && isTemplateColumnVisible(col.field)" [title]="template.id">{{ template.id }}</td>
            <td *ngIf="col.field === 'name' && isTemplateColumnVisible(col.field)" [title]="template.name">{{ template.name }}</td>
            <td *ngIf="col.field === 'type' && isTemplateColumnVisible(col.field)" class="template-type-cell">
              <sh-badge [label]="template.type" size="medium" [attr.neutral]="template.type === 'Personal' ? '' : null"></sh-badge>
            </td>
            <td *ngIf="col.field === 'comments' && isTemplateColumnVisible(col.field)" [title]="template.comments">{{ template.comments || '—' }}</td>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="templateColumns.length + 1" class="no-data-cell">
            <sh-spinner *ngIf="isLoadingTemplates || isTemplateOthersSearchLoading"></sh-spinner>
            <span *ngIf="!isLoadingTemplates && !isTemplateOthersSearchLoading && !isShowingTemplateOthersResults">No templates found</span>
            <span *ngIf="!isLoadingTemplates && !isTemplateOthersSearchLoading && isShowingTemplateOthersResults">
              No templates found for "{{ templateGlobalSearchText }}" from other users.
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="template-modal-content" *ngIf="activeTab === 'query'">
    <div class="search-row">
      <sh-search
        id="q-tmpl-global-search"
        class="template-global-search"
        no-border
        [label]="'allQueryTable.searchByNameTemplateId' | translate"
        (input)="onQueryGlobalSearchInput($event)"
        (clearsearch)="onQueryGlobalSearchClear()">
      </sh-search>
      <sh-tooltip delay target="q-tmpl-global-search" [label]="'allQueryTable.tooltip.searchTemplate' | translate" placement="bottom" variation="long"></sh-tooltip>
      <sh-button
        id="q-tmpl-search-all"
        size="auto"
        label="Search All"
        [disabled]="isQueryOthersSearchLoading || !(queryGlobalSearchText || '').trim() || isShowingQueryOthersResults"
        (click)="onQuerySearchOthers()"
        (keydown)="onQuerySearchOthers()">
      </sh-button>
      <sh-tooltip delay target="q-tmpl-search-all" [label]="'allQueryTable.tooltip.searchAll' | translate" placement="bottom" variation="long"></sh-tooltip>

    </div>
    <div class="summary-row">
      <sh-text size="body-2" class="total-count">
        <strong>Showing</strong> Queries:
        <strong>({{ filteredQueries.length }})</strong>
      </sh-text>

      <div class="header-icons">
        <sh-icon icon="layout-3x1" button color="black" size="m" id="q-tmpl-cols-icon"
          (click)="toggleQueryColumnVisibilityPopup()" (keydown)="toggleQueryColumnVisibilityPopup()"></sh-icon>
        <sh-popover
          class="template-columns-popover"
          sticky
          [visible]="showQueryColumnVisibilityPopup"
          target="q-tmpl-cols-icon"
          label="Choose Columns"
          modal-height='20vh'
          modal-width='20vw'
          style="z-index: 106;">
          <ul class="template-columns-list">
            <li class="template-columns-item" *ngFor="let column of queryTableColumns">
              <div class="template-columns-label">
                <sh-checkbox
                  [(ngModel)]="column.visible"
                  (checked)="onQueryColumnVisibilityChange(column, $event)">
                </sh-checkbox>
                <span>{{ column.label }}</span>
              </div>
            </li>
          </ul>
          <sh-button
            id="q-tmpl-cols-close"
            class="template-columns-close"
            label="Close"
            slot='footer'
            color="Tertiary"
            size="auto"
            (click)="toggleQueryColumnVisibilityPopup()">
          </sh-button>
        </sh-popover>
        <sh-tooltip delay target="q-tmpl-cols-icon" [label]="'allQueryTable.tooltip.chooseColumns' | translate" placement="top" variation="long"></sh-tooltip>
        <sh-tooltip delay target="q-tmpl-cols-close" [label]="'allQueryTable.tooltip.closeColumns' | translate" placement="top" variation="short"></sh-tooltip>
      </div>
    </div>

    <div
      *ngIf="isShowingQueryOthersResults"
      style="display: flex; align-items: center; gap: 8px; padding: 6px 12px; background-color: #e8f4fd; border-left: 3px solid #006ADD; margin-bottom: 4px; margin-top: 2px;">
      <sh-icon icon="information" size="s" color="primary"></sh-icon>
      <sh-text size="body-2" style="align-content: center; margin-left: 5px">
        Showing query results from other users for "<strong>{{ queryGlobalSearchText }}</strong>"
      </sh-text>
    </div>

    <p-table
      class="template-table"
      styleClass="filter-criteria-modal-table"
      [value]="filteredQueries"
      [reorderableColumns]="true" (onColReorder)="onQueryColumnReorder($event)"
      [scrollable]="true" scrollHeight="flex" [tableStyle]="{'min-width': '50rem'}">

      <ng-template pTemplate="header">
        <tr>
          <th scope="col" class="select-col"></th>
          <th scope="col" *ngFor="let col of queryColumns" [ngClass]="'col-' + col.field" pReorderableColumn [pSortableColumn]="col.isSortable ? col.field : undefined" [hidden]="!isQueryColumnVisible(col.field)">
            <div class="column-title-sort" [id]="'q-tmpl-head-' + col.field">
              <span>{{ col.header }}</span>
              <p-sortIcon *ngIf="col.isSortable" [field]="col.field"></p-sortIcon>
            </div>
            <sh-tooltip delay [target]="'q-tmpl-head-' + col.field" [label]="col.headerTooltip | translate" placement="top" variation="long"></sh-tooltip>
          </th>
        </tr>

        <tr class="filter-inputs-row">
          <th scope="col" class="select-col"></th>
          <th scope="col" *ngFor="let col of queryColumns" [ngClass]="'col-' + col.field" [hidden]="!isQueryColumnVisible(col.field)">
            <sh-input-text *ngIf="col.field === 'id'" id="q-tmpl-search-id" condensed label="Search..."
              [(ngModel)]="templateIdSearchText" (ngModelChange)="onQuerySearch()"></sh-input-text>
            <sh-input-text *ngIf="col.field === 'name'" id="q-tmpl-search-name" condensed label="Search..."
              [(ngModel)]="templateNameSearchText" (ngModelChange)="onQuerySearch()"></sh-input-text>
            <sh-input-text *ngIf="col.field === 'comments'" id="q-tmpl-search-comments" condensed label="Search..."
              [(ngModel)]="templateCommentsSearchText" (ngModelChange)="onQuerySearch()"></sh-input-text>
            <sh-tooltip *ngIf="col.searchTooltip" delay [target]="'q-tmpl-search-' + col.field" [label]="col.searchTooltip | translate" placement="bottom" variation="short"></sh-tooltip>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-template let-i="rowIndex">
        <tr [class.selected-row]="selectedTemplateItem?._uid === template._uid" (click)="onTemplateRadioChange(template)">
          <td class="select-col">
            <span [id]="'q-tmpl-radio-' + i">
              <sh-radio-button
                label=""
                [active]="selectedTemplateItem?._uid === template._uid"
                (click)="$event.stopPropagation(); onTemplateRadioChange(template)"
                (keydown)="$event.stopPropagation(); onTemplateRadioChange(template)">
              </sh-radio-button>
            </span>
            <sh-tooltip delay [target]="'q-tmpl-radio-' + i" [label]="'filter-criteria.tooltip.queryRadio' | translate" placement="top" variation="short"></sh-tooltip>
          </td>
          <ng-container *ngFor="let col of queryColumns">
            <td *ngIf="col.field === 'favourite' && isQueryColumnVisible(col.field)">
              <ng-container *ngIf="template.isFavourite; else nonFavoriteQueryIcon">
                <div class="favorite-icon-wrapper">
                  <sh-icon class="favorite-icon-default" icon="favorite" size="s" color="primary" (click)="onToggleFavoriteinQuery(false, template)"></sh-icon>
                </div>
              </ng-container>
              <ng-template #nonFavoriteQueryIcon>
                <div class="favorite-icon-wrapper">
                  <sh-icon class="favorite-icon-hover" icon="favorite-off" size="s" color="primary" (click)="onToggleFavoriteinQuery(true, template)"></sh-icon>
                </div>
              </ng-template>
            </td>
            <td *ngIf="col.field === 'id' && isQueryColumnVisible(col.field)" [title]="template.id">{{ template.id }}</td>
            <td *ngIf="col.field === 'name' && isQueryColumnVisible(col.field)" [title]="template.name">{{ template.name }}</td>
            <td *ngIf="col.field === 'comments' && isQueryColumnVisible(col.field)" [title]="template.comments">{{ template.comments || '—' }}</td>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="queryColumns.length + 1" class="no-data-cell">
            <sh-spinner *ngIf="isLoadingTemplates || isQueryOthersSearchLoading"></sh-spinner>
            <span *ngIf="!isLoadingTemplates && !isQueryOthersSearchLoading && !isShowingQueryOthersResults">No queries found</span>
            <span *ngIf="!isLoadingTemplates && !isQueryOthersSearchLoading && isShowingQueryOthersResults">
              No queries found for "{{ queryGlobalSearchText }}" from other users.
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div slot="footer" class="modal-footer-buttons">
    <sh-button
      id="tt-tmpl-cancel"
      color="secondary"
      label="Cancel"
      (click)="closeTemplateModal()">
    </sh-button>
    <sh-tooltip delay target="tt-tmpl-cancel" [label]="'filter-criteria.tooltip.tmplCancel' | translate" placement="top" variation="short"></sh-tooltip>
    <sh-button
      id="tt-tmpl-load"
      label="Load"
      (click)="loadSelectedTemplate()"
      [disabled]="!selectedTemplateItem">
    </sh-button>
    <sh-tooltip delay target="tt-tmpl-load" [label]="'filter-criteria.tooltip.tmplLoad' | translate" placement="top" variation="long"></sh-tooltip>
  </div>
</sh-modal>
